import { useTranslation } from 'react-i18next';
import { Card, Container } from '@mui/material';
import Page from '../components/Page';
import LabelList from '../components/_dashboard/label/LabelList';
import HeaderBreadcrumbs from '../components/HeaderBreadcrumbs';
import { PATH_CLIENT } from '../routes/paths';
// ----------------------------------------------------------------------

export default function Label() {
  const { t } = useTranslation();

  return (
    <Page title={t('my_labels')}>
      <Container maxWidth="lg">
        <HeaderBreadcrumbs
          heading={t('my_labels')}
          links={[{ name: 'Dashboard', href: PATH_CLIENT.root }, { name: t('my_labels') }]}
        />
        <Card>
          <LabelList />
        </Card>
      </Container>
    </Page>
  );
}
